import { Controller } from '@hotwired/stimulus';
import { getWindowWidth } from 'lib/helpers';

export default class StickyAdContainerController extends Controller {
  connect() {
    if (this.showStickyAd()) return;

    this.destroyElement();
  }

  destroyElement() {
    this.element.remove();
  }

  showStickyAd() {
    return getWindowWidth() > 1399;
  }

  get isCustomSalesEventActive() {
    return document.body.classList.contains('custom-sales-event-active');
  }
}
